module.exports = __webpack_public_path__ + "static/media/Heebo-Medium.3fa38b8f.ttf";